module.exports = __webpack_public_path__ + "img/haze-light.9492c3b6.png";